const initialCalendar = () => {
	const newDate = new Date();

	const initialTimeslots = [];

	let lastDayOfMonth = 32 - new Date(newDate.getFullYear(), newDate.getMonth(), 32).getDate();
	let currentDate = newDate.getDate();

	if (currentDate === lastDayOfMonth) {
		const currentMonth = newDate.getMonth();

		newDate.setDate(1);

		if (currentMonth === 11) {
			newDate.setMonth(0);
			newDate.setFullYear(newDate.getFullYear() + 1);
		} else {
			newDate.setMonth(currentMonth + 1);
		}

		lastDayOfMonth = 32 - new Date(newDate.getFullYear(), newDate.getMonth(), 32).getDate();
		currentDate = newDate.getDate();
	}

	for (let i = currentDate; i < lastDayOfMonth + 1; i++) {
		const nextDate = new Date(newDate.getFullYear(), newDate.getMonth(), i);

		nextDate.setHours(nextDate.getHours() + 3);

		initialTimeslots.push({
			startDateTime: nextDate.toISOString(),
			endDateTime: nextDate.toISOString(),
		});

		nextDate.setHours(nextDate.getHours() + 6);

		initialTimeslots.push({
			startDateTime: nextDate.toISOString(),
			endDateTime: nextDate.toISOString(),
		});

		nextDate.setHours(nextDate.getHours() + 4);

		initialTimeslots.push({
			startDateTime: nextDate.toISOString(),
			endDateTime: nextDate.toISOString(),
		});
	}

	return initialTimeslots;
};

export {
	initialCalendar,
};
